export default __webpack_public_path__ + "static/media/45016.d68bcaaa.jpg";